import plans from "../components/plans/data/plans";

const isPlanHighEnough = (currentPlanName, planNameToCheckAgainst) => {
  return plans.findIndex(plan => plan.name === currentPlanName) >= plans.findIndex(plan => plan.name === planNameToCheckAgainst);
};

export default isPlanHighEnough;
